import { Check, Gift } from "lucide-react";
import { useT } from "@/lib/i18n";

export const StampCard = ({ program, member, accent = "#D9531E" }) => {
  const { t } = useT();
  const required = program?.stamps_required || 8;
  const filled = member?.stamps || 0;
  const hasReward = (member?.rewards_available || 0) > 0;
  const dots = Array.from({ length: required }, (_, i) => i < filled);
  const cardUrl = member?.card_token && member?.restaurant_id
    ? `${window.location.origin}/loyalty/${member.restaurant_id}?card=${member.card_token}`
    : null;

  return (
    <div data-testid="stamp-card" className="rounded-2xl p-5 border border-[#E6E1DA] bg-white">
      <div className="flex items-center justify-between">
        <div>
          <p className="font-sub font-bold text-[#1F1D1B]">{program?.program_name || t("loyaltyRewards")}</p>
          <p className="text-xs text-[#6B6560]">{t("stampsCount", { n: filled, r: required })}</p>
        </div>
        <div className="h-10 w-10 rounded-xl grid place-items-center" style={{ backgroundColor: `${accent}20` }}>
          <Gift className="h-5 w-5" style={{ color: accent }} />
        </div>
      </div>

      <div className="grid grid-cols-4 gap-2.5 mt-4">
        {dots.map((on, i) => (
          <div
            key={i}
            className="aspect-square rounded-full grid place-items-center text-xs font-bold border-2 transition-all"
            style={on ? { backgroundColor: accent, borderColor: accent, color: "#fff" } : { borderColor: "#E6E1DA", color: "#C9C2B8" }}
          >
            {on ? <Check className="h-4 w-4" /> : i + 1}
          </div>
        ))}
      </div>

      <div className="mt-4 rounded-xl p-3 text-sm" style={{ backgroundColor: `${accent}12`, color: "#1F1D1B" }}>
        <span className="font-semibold">{t("rewardLabel")}</span> {program?.reward_description || t("freeItem")}
      </div>

      {cardUrl && (
        <div data-testid="member-qr" className="mt-4 flex items-center gap-3 rounded-xl border border-[#E6E1DA] p-3">
          <img src={`https://api.qrserver.com/v1/create-qr-code/?size=130x130&margin=6&data=${encodeURIComponent(cardUrl)}`} alt="Card QR" className="h-20 w-20 rounded-lg bg-white" />
          <div className="text-xs text-[#6B6560] leading-relaxed">
            <p className="font-sub font-semibold text-sm text-[#1F1D1B]">{t("scanPullCard")}</p>
            <p>{t("scanPullDesc")}</p>
          </div>
        </div>
      )}

      {hasReward && (
        <div data-testid="reward-ready-banner" className="mt-3 rounded-xl p-4 text-center text-white fade-up" style={{ backgroundColor: accent }}>
          <p className="font-sub font-bold">🎉 {t("rewardUnlocked")}</p>
          <p className="text-xs mt-1 opacity-90">{t("showCode")}</p>
          <p className="font-mono-j text-lg font-bold tracking-widest mt-1">{member?.redeem_code}</p>
          {member?.rewards_available > 1 && <p className="text-xs mt-1 opacity-90">{t("rewardsAvailable", { n: member.rewards_available })}</p>}
        </div>
      )}
    </div>
  );
};
